// local environment config
export default {
    LOGIN_URL: "https://vportalsmi.sms-group.com/auth/login/?redirectUrl=" + encodeURIComponent('https://vportalsmi.sms-group.com'),
    BACKEND_URL: "https://vportalsmi.sms-group.com/api/",
    FILE_SERVER_URL: "https://vportalsmi.sms-group.com/files/api/",
    FRONT_END_URL: 'https://vportalsmi.sms-group.com/'
}


// Server Config
// export default {
//     LOGIN_URL: "http://10.182.8.123:8002/login/?redirectUrl=" + encodeURIComponent('http://10.182.8.123:3000/'),
//     BACKEND_URL: "http://10.182.8.123:8000/api/",
//     FILE_SERVER_URL: "http://10.182.8.123:8001/api/",
//     FRONT_END_URL: 'http://10.182.8.123:3000/'
// }

